import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';
import { hlcity } from './hlcity';

/** The Seaview Hotel (海景飯店) in Hualien city: lobby with the reception, and your room with a view of the Pacific. */
const b = new MapBuilder(14, 10, ' ');
b.room(0, 0, 14, 10, 'z');
b.room(7, 0, 7, 6, ':'); // the guest room (carpeted)
b.fill(9, 5, 2, 1, 'd');
b.fill(6, 9, 2, 1, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });

const decor: Decor[] = [
  { kind: 'window', x: px(9), y: 0, w: px(3), wall: true },
  { kind: 'painting', x: px(2), y: 3, wall: true, variant: 0 },
  { kind: 'mapBoard', x: px(11), y: px(5) + 2, wall: true },
  { kind: 'poster', x: px(8) + 2, y: px(5) + 3, wall: true, variant: 1 },
  { kind: 'pottedPlant', x: px(1) + 8, y: px(8) + 12, solid: { x: px(1) + 2, y: px(8) + 6, w: 12, h: 6 } },
  { kind: 'armchairs', ...at(3, 7), w: px(3), solid: { x: px(2), y: px(7) - 8, w: px(3), h: 8 } },
  { kind: 'pottedPlant', x: px(12) + 8, y: px(8) + 12, solid: { x: px(12) + 2, y: px(8) + 6, w: 12, h: 6 } },
];

export const hotel: MapDef = {
  id: 'hotel',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#eef3f2', wallLight: '#ffffff', wainscot: '#2f8fa8', wallTop: '#22303a' },
  doors: [{ tiles: [[6, 9], [7, 9]], to: 'hlcity', arrive: hlcity.spots!.hotelDoor }],
  decor,
  areas: [{ key: 'hotel', rect: { x: 0, y: 0, w: px(14), h: px(10) } }],
  lights: [
    { x: px(3), y: px(4), r: 90, color: '255,230,190' },
    { x: px(10), y: px(3), r: 80, color: '255,220,170' },
  ],
};
